import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import commonEn from "./en/commonEn";
import userEn from "./en/userEn";
import commonHi from "./hi/commonHi";
import userHi from "./hi/userHi";
import eventEn from "./en/eventEn";
import eventHi from "./hi/eventHi";

const resources = {
    en: {
        translation: {
            ...commonEn,
            ...userEn,
            ...eventEn,
        }
    },
    hi: {
        translation: {
            ...commonHi,
            ...userHi,
            ...eventHi,
        }
    },
};

// Initialize i18next
i18n.use(initReactI18next).init({
    resources,
    lng: "en", // Default language
    fallbackLng: "en",
    interpolation: { escapeValue: false }
});

export default i18n;